import { ThemeColors } from '~/themes/colors'

export interface NewFaxLoadingViewColors {
  Background: ThemeColors
  CircularProgress: {
    TrackColor: ThemeColors
    ProgressColor: ThemeColors
  }
}

export const newFaxLoadingViewColors: NewFaxLoadingViewColors = {
  Background: {
    default: 'achromatic.transparent',
  },
  CircularProgress: {
    TrackColor: {
      default: 'gray.300',
    },
    ProgressColor: {
      default: 'blue.900',
    },
  },
}
